function formatDateTimeServer(now,millesecond=0) {
    const options = {
        timeZone: 'Europe/Moscow',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
    };
    const dateAgo = new Date(now.getTime() - millesecond);



    const dateTimeFormat = new Intl.DateTimeFormat('ru-RU', options);

    // Получаем форматированную строку
    const [
        { value: day },,
        { value: month },,
        { value: year },,
        { value: hour },,
        { value: minute },,
        { value: second }
    ] = dateTimeFormat.formatToParts(dateAgo);

    return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
}

export default formatDateTimeServer